import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { AboutUs } from "./components/AboutUs";
import { Studio } from "./components/Studio";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { MaintenancePage } from "./pages/MaintenancePage";
import { StudioMaintenancePage } from "./pages/StudioMaintenancePage";
import { ContactPage } from "./pages/ContactPage";
import { PageTransitionProvider } from "./components/PageTransition";

// Component to scroll to top on route change and page refresh (not on tab switch)
const ScrollToTop = () => {
  const location = useLocation();
  
  // Scroll to top on route change (except when scrolling to specific section)
  useEffect(() => {
    if (!location.state?.scrollToSection && !location.state?.scrollToAll) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.state]);
  
  return null;
};

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle scroll to section when coming back from detail pages
    if (location.state?.scrollToSection) {
      const sectionId = location.state.scrollToSection;
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerHeight = 65;
          const elementTop = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: elementTop - headerHeight, behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.state]);

  return (
    <div className="page-wrapper">
      <Header />
      <Hero />
      <AboutUs />
      <Studio />
      <Contact />
      {/* Maintenance Banner */}
      <section className="maintenance-banner">
        <div className="maintenance-banner-content">
          <p className="maintenance-banner-text">
            We&apos;re updating our website. Check back soon.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

// Wrapper component that includes the transition provider
const AppRoutes = () => {
  return (
    <PageTransitionProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<MaintenancePage title="Projects" />} />
        <Route path="/projects/:id" element={<MaintenancePage title="Projects" />} />
        <Route path="/studio" element={<StudioMaintenancePage />} />
        <Route path="/gallery" element={<MaintenancePage title="Gallery" />} />
        <Route path="/gallery/:id" element={<MaintenancePage title="Gallery" />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </PageTransitionProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
